import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../environments/environment';

import {
  ResourceKnowledge,
  ResourceCategory
} from '../Models/resource.models';

export interface SkillSaveRequest {
  name: string;
  color?: string;
  /** Nur beim Anlegen: null = globaler Skill, sonst Skill nur für dieses Team. */
  teamId?: number | null;
}

export interface CategorySaveRequest {
  name: string;
  color: string;
  countsAsAbsence: boolean;
  excludeFromCapacity?: boolean;
  sortOrder: number;
  /** Nur beim Anlegen: null = globale Kategorie, sonst Kategorie nur für dieses Team. */
  teamId?: number | null;
}

/**
 * Skills und Kategorien anlegen, bearbeiten, löschen. Ob ein Eintrag global oder
 * teamspezifisch ist, entscheidet teamId beim Anlegen; die Berechtigung prüft das Backend.
 */
@Injectable({
  providedIn: 'root'
})
export class ResourceManagementApiService {

  private readonly apiUrl =
    environment.apiBaseUrl + '/resourceplanning';

  constructor(private http: HttpClient) {}

  createSkill(
    payload: SkillSaveRequest
  ): Observable<ResourceKnowledge> {
    return this.http.post<ResourceKnowledge>(
      `${this.apiUrl}/skills`,
      payload
    );
  }

  updateSkill(
    id: number,
    payload: SkillSaveRequest
  ): Observable<ResourceKnowledge> {
    return this.http.put<ResourceKnowledge>(
      `${this.apiUrl}/skills/${id}`,
      payload
    );
  }

  deleteSkill(id: number): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}/skills/${id}`
    );
  }

  createCategory(
    payload: CategorySaveRequest
  ): Observable<ResourceCategory> {
    return this.http.post<ResourceCategory>(
      `${this.apiUrl}/categories`,
      payload
    );
  }

  updateCategory(
    id: number,
    payload: CategorySaveRequest
  ): Observable<ResourceCategory> {
    return this.http.put<ResourceCategory>(
      `${this.apiUrl}/categories/${id}`,
      payload
    );
  }

  deleteCategory(id: number): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}/categories/${id}`
    );
  }
}
